window.DOLOBITES_SUMMARY = (() => {
  const getElement = (booking, selector) =>
    booking.querySelector(selector);

  const setText = (element, value, fallback = 'Not selected') => {
    if (!element) return;

    const cleanValue =
      typeof value === 'string' ? value.trim() : value;

    element.textContent =
      cleanValue || cleanValue === 0 ? cleanValue : fallback;
  };

  const formatEventDate = (dateValue) => {
    if (!dateValue) return 'Not selected';

    const date = new Date(`${dateValue}T12:00:00`);

    if (Number.isNaN(date.getTime())) {
      return dateValue;
    }

    return new Intl.DateTimeFormat('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    }).format(date);
  };

  const getFlavoursText = (selectedFlavours = []) => {
    if (!selectedFlavours.length) return 'Not selected';

    return selectedFlavours
      .map((flavour) => flavour.name)
      .join(', ');
  };

  const getExtrasText = (selectedExtras = []) => {
    if (!selectedExtras.length) return 'None';

    return selectedExtras
      .map((extra) => extra.name)
      .join(', ');
  };

  const update = ({
    booking,
    state,
    totals
  }) => {
    if (!booking || !state || !totals) return;

    setText(
      getElement(booking, '#db-summary-date'),
      formatEventDate(state.date)
    );

    setText(
      getElement(booking, '#db-summary-event'),
      state.eventType
    );

    setText(
      getElement(booking, '#db-summary-location'),
      state.location
    );

    setText(
      getElement(booking, '#db-summary-guests'),
      state.guests,
      '0'
    );

    setText(
      getElement(booking, '#db-summary-package'),
      state.selectedPackage?.name,
      state.customQuote
        ? 'Custom quote'
        : 'Not selected'
    );

    setText(
      getElement(booking, '#db-summary-flavours'),
      getFlavoursText(state.selectedFlavours)
    );

    setText(
      getElement(booking, '#db-summary-extras'),
      getExtrasText(state.selectedExtras),
      'None'
    );

    setText(
      getElement(booking, '#db-summary-total'),
      window.DOLOBITES_PRICING.formatCurrency(
        totals.total,
        totals.total % 1 !== 0
      ),
      '$0'
    );

    setText(
      getElement(booking, '#db-summary-deposit'),
      window.DOLOBITES_PRICING.formatCurrency(
        totals.deposit,
        totals.deposit % 1 !== 0
      ),
      '$0'
    );
  };

  return {
    update
  };
})();